module.exports = __webpack_public_path__ + "img/icon2@2x.40eee2b6.png";